export const Roles = Object.freeze({
  ADMIN: 1,
  CREATOR: 8,
  MANAGER: 2,
  MANAGER_LIMITED: 9,
  VIEWER: 4,
  VIEWER_LIMITED: 6,
  RIGHT_HOLDER: 11,
});
